import { FC } from 'react'

interface EmptyHexProps {
  potentialMove?: boolean
}

export const EmptyHex: FC<EmptyHexProps> = ({ potentialMove = false }) => {
  const fill = potentialMove ? '#B1D93F' : '#777777'
  const fillOpacity = potentialMove ? 0.1 : 0.01
  const stroke = `url(#${potentialMove ? 'active-grad' : 'non-active-grad'})`
  const strokeOpacity = potentialMove ? 1 : 0.8
  const strokeWidth = potentialMove ? 2.5 : 2

  return (
    <svg width="275" height="300" viewBox="0 0 55 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_bi_54_870)">
        <path
          d="M50.9335 47.8068C53.4184 46.3803 54.9507 43.7339 54.9507 40.8687V19.1326C54.9507 16.2675 53.4185 13.6211 50.9338 12.1946L31.9338 1.28669C29.4672 -0.129381 26.4342 -0.129383 23.9676 1.28669L4.96761 12.1946C2.48287 13.6211 0.950684 16.2675 0.950684 19.1326V40.8687C0.950684 43.7339 2.48299 46.3803 4.96789 47.8068L23.9679 58.7137C26.4343 60.1295 29.467 60.1295 31.9335 58.7137L50.9335 47.8068Z"
          fill={fill}
          fillOpacity={fillOpacity}
        />
        <path
          d="M53.9507 40.8687C53.9507 43.3757 52.6099 45.6914 50.4356 46.9395L31.4356 57.8464C29.2775 59.0853 26.6239 59.0853 24.4657 57.8464L5.46573 46.9395C3.29145 45.6914 1.95068 43.3758 1.95068 40.8687V19.1326C1.95068 16.6256 3.29135 14.31 5.46549 13.0619L24.4655 2.15394C26.6238 0.914869 29.2776 0.914871 31.4359 2.15394L50.4359 13.0619C52.61 14.31 53.9507 16.6256 53.9507 19.1326V40.8687Z"
          stroke={stroke}
          strokeOpacity={strokeOpacity}
          strokeWidth={strokeWidth}
        />
      </g>
      <defs>
        <filter
          id="filter0_bi_54_870"
          x="-11.0493"
          y="-11.7754"
          width="78"
          height="83.5509"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_54_870" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_54_870" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_54_870" />
        </filter>

        <linearGradient id="active-grad" x1="27.9507" y1="-1" x2="27.9507" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#B1D93F" />
          <stop offset="1" stopColor="#148F00" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="non-active-grad" x1="27.9507" y1="-1" x2="27.9507" y2="61" gradientUnits="userSpaceOnUse">
          <stop stopColor="#172C3F" />
          <stop offset="1" stopColor="#12474A" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
